<div class="container">
  <ng-container>
    <div class="user-row">
      <div class="title beta" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_MY_RIGHTS"></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>

    <div class="user-row head">
      <div fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_NAME"></div>
      <div fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_EMAIL"></div>
      <div fiTranslation="USER_RIGHTS_DETAILS_LOGIN"></div>
      <div fiTranslation="USER_MANAGEMENT_OVERVIEW_TABLE_HEADER_3"></div>
      <div fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_LASTLOG" class="padding"></div>
      @if (isCloudUser) {
        <div class="center">
          <span fiTranslation="USER_MANAGEMENT_OVERVIEW_TABLE_HEADER_5"></span>
        </div>
      }
    </div>
    <div class="line"></div>
    <fi-user-card [hideToggle]="!fetchedDeactivatedUsers" [isCloudUser]="isCloudUser" [activated]="!deactivatedUsers.has(employee?.User?.Id)" (openDeactivationDialog)="onOpenDeactivateDialog(employee)" [isClickable]="false" class="user-row" [user]="employee"></fi-user-card>


    @if (employees.length > 0) {
      <div class="user-row">
        <div class="title" fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_TEAM"></div>
        <div></div>
        <div></div>
        <div></div>
        @if (isCloudUser) {
          <div></div>
        }
        <div>
          <a class="new-user-btn" [href]="newUserUrl" target="_blank"><img src="assets/icons/user.svg" alt="user"><span fiTranslation="USER_RIGHTS_LINK_CREATE_USER"></span></a>
        </div>
      </div>
    }

    @if (employees.length > 0) {
      <div class="user-row head">
        <div fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_NAME"></div>
        <div fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_EMAIL"></div>
        <div fiTranslation="USER_RIGHTS_DETAILS_LOGIN"></div>
        <div fiTranslation="USER_MANAGEMENT_OVERVIEW_TABLE_HEADER_3"></div>
        <div fiTranslation="USER_PROFILE_RIGHTS_HEADLINE_LASTLOG" class="padding"></div>
        @if (isCloudUser) {
          <div class="center">
            <span fiTranslation="USER_MANAGEMENT_OVERVIEW_TABLE_HEADER_5"></span>
          </div>
        }
      </div>
    }
    <div class="line"></div>

    @for (subordinate of employees; track subordinate) {
      <fi-user-card [hideToggle]="!fetchedDeactivatedUsers" [isCloudUser]="isCloudUser" [activated]="!deactivatedUsers.has(subordinate.User?.Id)" (openDeactivationDialog)="onOpenDeactivateDialog(subordinate)" (openUserDetails)="onOpenUserDetails(subordinate)" class="user-row" [user]="subordinate"></fi-user-card>
    }
  </ng-container>
</div>
